import { commons, inheritorDocs, others } from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

export const PPMHerdeiroDocs = () => {
  const rules = {
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
    anexoHerdeiro: dynamicRule('required'),
    anexoDeclaracaoHerdeiros: dynamicRule('required'),
    anexoOutros: dynamicRule(),
  };

  const docs = {
    commons: [...commons, ...inheritorDocs, ...others],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
